import React from "react";

export default function Benifits() {
  return (
    <div id="solutionchallenge" className="w-full flex flex-col pb-20 pt-5 items-center text-white">
      <p className="text-sm border-b uppercase text-sky-800 pr-10 pb-2 font-medium border-sky-800 dark:border-gray-100 dark:text-white">
        Make an Impact
      </p>
      <h1 className="text-sky-800 my-10 dark:text-white  w-10/12 text-center md:w-5/12 ml-auto mr-auto text-3xl md:text-5xl font-bold">
        Want to do something
        <span className="text-sky-500"> For the community</span>
      </h1>
      <div className="w-10/12 md:w-9/12">
        <div className="grid rounded-2xl p-12 gap-5 md:grid-cols-2 bg-whitepaper bg-cover bg-center shadow-2xl shadow-sky-500/25">
          <div className="flex flex-col justify-center">
            <h1 className="text-5xl font-bold">
              {" "} <br />
              <span className="text-sky-500">Soultion Challenge</span>
            </h1>
            {/* <p className="mt-5">
              Here is the link to help you understand about Google's Solution Challenge
            </p> */}
            <a target="__blank" href="https://developers.google.com/community/gdsc-solution-challenge" className="mt-10 w-40 text-center bg-sky-500 dark:bg-sky-500 text-white transition-all px-6 py-3 rounded-full dark:hover:bg-sky-600 hover:shadow-lg hover:shadow-sky-500/25">
              Learn more
            </a>
          </div>
          <div className="lg:mx-10">
          </div>
        </div>
      </div>
    </div>
  );
}
